import React from 'react';
import { Box, Button, Card, Chip, Typography } from '@mui/material';
import moment from 'moment';
import { LeaveStatusType } from '../../constants';
import RemoteOfficeHoursQuotaApprovalStatus from './RemoteOfficeHoursQuotaApprovalStatus';
import { getHHMMSSFromSeconds } from '../../utils/TimeConversionFunctions';

const secondsToHoursLabel = (secs) => {
  const hours = Number(secs) / 3600;
  if (Number.isNaN(hours)) {
    return '—';
  }
  return `${Number(hours.toFixed(2))} hrs`;
};

const RemoteOfficeHoursQuotaCard = ({
  request,
  variant = 'employee',
  projectName,
  employeeName,
  onApprove,
  onReject,
  onCancel,
}) => {
  const statusColor =
    request.status === LeaveStatusType.APPROVED
      ? 'success'
      : request.status === LeaveStatusType.REJECTED
        ? 'error'
        : 'warning';

  return (
    <Card variant="outlined" sx={{ mb: 2, p: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
        <Box sx={{ flex: 1, minWidth: 200 }}>
          {variant !== 'employee' && (
            <Typography variant="subtitle1">
              {employeeName || request.employeeId}
            </Typography>
          )}
          <Typography variant="body1">
            {secondsToHoursLabel(request.requestedHours)} — {request.status}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {projectName ? `Project: ${projectName}` : request.projectId ? `Project #${request.projectId}` : ''}
            {request.quotaMonth ? ` · ${moment(request.quotaMonth).format('MMM YYYY')}` : ''}
          </Typography>
          {request.reportingManagerId && (
            <Typography variant="caption" color="text.secondary" display="block">
              Routed to reporting manager
            </Typography>
          )}
          {request.description && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              {request.description}
            </Typography>
          )}
          <Chip
            size="small"
            label={request.status}
            color={statusColor}
            variant="outlined"
            sx={{ mt: 1 }}
          />
          <RemoteOfficeHoursQuotaApprovalStatus request={request} />
        </Box>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
          {variant === 'employee' && request.status === LeaveStatusType.PENDING && onCancel && (
            <Button size="small" color="error" onClick={() => onCancel(request)}>
              Cancel
            </Button>
          )}
          {variant !== 'employee' && request.status === LeaveStatusType.PENDING && (
            <>
              {onReject && (
                <Button
                  size="small"
                  color="error"
                  variant="outlined"
                  onClick={() => onReject(request)}
                >
                  Reject
                </Button>
              )}
              {onApprove && (
                <Button
                  size="small"
                  color="success"
                  variant="outlined"
                  onClick={() => onApprove(request)}
                >
                  Approve
                </Button>
              )}
            </>
          )}
        </Box>
      </Box>
    </Card>
  );
};

export default RemoteOfficeHoursQuotaCard;
